import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../../environments/environment';
import { ParentService } from '../../A2-utils/ParentClass/ParentService';

export interface IAdditionalPayor {
  additionalpayorid: number;
  description: string;
  riderid: number;
  note: string;
  memberid: string;
  modifiedon: Date;
  addedon: Date;
}

@Injectable()
export class AditionalPayorService  extends ParentService  {

  resource: string;

  constructor(private http: Http) {
    super();
    this.resource = `${environment.url_api}AdditionalPayor`;
  }

  getAll() {
    return this.http.get(`${this.resource}`, this.getHeader());
  }

  get(riderid: number) {
    return this.http.get(`${this.resource}/ByRider/${riderid}`, this.getHeader())
    .map(res => res.json())
    .catch(err => Observable.throw(err));
  }

  put(data: any) {
    return this.http.put(`${this.resource}`, data, this.headerPost())
      .map((res) => res.json())
      .catch(err => Observable.throw(err));
  }

  post(data: any) {
    return this.http.post(`${this.resource}`, data, this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  delete(additionalpayorid: number) {
    return this.http.delete(`${this.resource}/${additionalpayorid}`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/rider/services/aditional-payor.service.ts